// 这是一个例子
export const example = state => { return state.home.example }
// 这是当前频道的模板id
export const curModelInfo = state => { return state.home.curModelInfo }
// 所有频道信息
export const modelsInfo = state => { return state.home.modelsInfo }
// 网站拥有的模块
export const webModels = state => { return state.home.webModels }
// 当前的专题
export const curSpecial = state => state.special.curSpecial

export const webID = state=>state.home.webid

//是否隐藏底部
export const hidefooter = state=>state.home.hidefooter


//当前被点击的频道
export const activeChanelIndex = state=>state.home.active_chanel_index

export const logo_src = state=>state.home.logosrc

export const login_success = state=>state.home.loginsuccess


// sort:"1",//排序方式，1位入库时间        2为拍摄时间
// struct:"1",  //构图方式
// startTime:"",//开始时间
// endTime:"",  //结束时间

export const sort = state=>state.home.sort
export const struct = state=>state.home.struct
export const startTime = state=>state.home.startTime
export const endTime = state=>state.home.endTime

//2019 7 18 添加

export const isGaonS = state => state.home.isGaonS
export const isEnglish = state => state.home.isEnglish
export const area = state=>state.home.area
export const countrydata = state=>state.home.countrydata
export const citydata = state=>state.home.citydata



// WEBPACK FOOTER //
// ./src/store/getters.js